import React from "react";
import { useCartCount } from "./StoreContext";
import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import pluralize from "pluralize";

const query = graphql`
  query {
    allShopifyProduct(sort: { fields: [title] }) {
      group(field: variants___product___productType) {
        fieldValue
      }
    }
  }
`;

export const TopNav = () => {
  const { allShopifyProduct } = useStaticQuery(query);
  const count = useCartCount();
  const types = allShopifyProduct.group.map((productType) =>
    pluralize(productType.fieldValue)
  );

  const [navbarOpen, setNavbarOpen] = React.useState(false);

  const typeLinks = types.map((type, id) => {
    return (
      <a
        key={id}
        className={`${
          navbarOpen
            ? "block font-medium text-lg pt-2 pr-0 pb-4 pl-8"
            : "md:text-black-500 hover:bg-blue-900 hover:text-white px-3 py-2"
        }`}
        style={{ textDecoration: "none" }}
        href={`/${type}`}
      >
        {type}
      </a>
    );
  });

  return (
    <div className="border-blue-500 border-b-2">
      <nav className="py-4 px-2 md:px-6 max-w-screen-xl m-auto ">
        <div className="max-w-7xl mx-auto px-2 md:px-6 lg:px-8">
          <div className="relative flex items-center justify-between h-16">
            <div className="absolute inset-y-0 left-0 flex items-center md:hidden">
              <button
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-white hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-expanded="false"
                onClick={() => setNavbarOpen(!navbarOpen)}
              >
                <svg
                  className="block h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <svg
                  className="hidden h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  />
                </svg>
              </button>
            </div>
            <div className="flex-1 flex items-center justify-center md:items-stretch md:justify-start">
              <div className="flex-shrink-0 flex items-center">
                <StaticImage
                  className="h-16 w-16 rounded-full mb-4 md:mb-0 mr-20"
                  src="../img/logo.jpg"
                  alt="logo"
                  placeholder="blurred"
                />
              </div>
              <div className="hidden md:block md:ml-6 mt-3">
                <div>
                  <div className="flex space-x-4">
                    <a
                      className="text-black-500 hover:bg-blue-900 hover:text-white px-3 py-2"
                      style={{ textDecoration: "none" }}
                      href="/"
                    >
                      Featured
                    </a>
                    {typeLinks}
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 md:static md:inset-auto md:ml-6 md:pr-0">
              <div className="ml-3 relative">
                <div>
                  <a className="h-8 w-8 rounded-full" href="/shopping-cart">
                    Cart - {count}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${
            navbarOpen
              ? "w-3/5 h-full fixed pt-16 z-10 top-0 left-0 bg-white overflow-hidden"
              : "hidden"
          } md:hidden`}
          style={{
            color: "#818181",
          }}
        >
          <a
            className="absolute top-0 ml-14 font-medium text-4xl"
            onClick={() => setNavbarOpen(!navbarOpen)}
            style={{
              right: "25px",
            }}
          >
            &times;
          </a>
          <a href="/" className="block font-medium text-lg pt-2 pr-0 pb-4 pl-8">
            Featured
          </a>
          {typeLinks}
        </div>
      </nav>
    </div>
  );
};
